'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _Player2 = require('../models/Player');

var _Player3 = _interopRequireDefault(_Player2);

var _timeToPercentage = require('../utils/timeToPercentage');

var _timeToPercentage2 = _interopRequireDefault(_timeToPercentage);

var _percentageToTime = require('../utils/percentageToTime');

var _percentageToTime2 = _interopRequireDefault(_percentageToTime);

var _htmlMediaEvents = require('../constants/htmlMediaEvents');

var _htmlMediaEvents2 = _interopRequireDefault(_htmlMediaEvents);

var _debugger = require('../../debugger');

var _debugger2 = _interopRequireDefault(_debugger);

var _logError = require('../../loggers/logError');

var _logError2 = _interopRequireDefault(_logError);

var _logging = require('../hlsjs/constants/logging');

var _playerName = require('../constants/playerName');

var _playerName2 = _interopRequireDefault(_playerName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AVAILABLE_DURATION_HEADER = 'x-tunein-playlist-available-duration'; /* eslint-disable no-underscore-dangle */

var DURATION_POLLING_INTERVAL = 5000;
var LIVE_HEAD_DELAY = 20;

/**
 * See https://tunein.atlassian.net/wiki/spaces/FNS/pages/232620284/Requesting+HLS+Streams+Playlist+Service+params
 * for details about these parameters and how they relate to LiveSeek implementation.
 * @param url {string}
 * @param time {number}
 * @returns {string}
 */
var liveSeekUrlBuilder = {
  start: function start() {
    this.parts = [];
    return this;
  },
  posStart: function posStart(time) {
    // Default to 1 for pos_start and pos_end since the streaming API doesn't
    // recognize 0 from the value not being set.
    this.parts.push('pos_start=' + (time || 1));
    return this;
  },
  posEnd: function posEnd(time) {
    this.parts.push('pos_end=' + (time || 1));
    return this;
  },
  segs: function segs(number) {
    this.parts.push('segs=' + number);
    return this;
  },
  finish: function finish(streamUrl) {
    var _streamUrl$split = streamUrl.split('?'),
        _streamUrl$split2 = (0, _slicedToArray3.default)(_streamUrl$split, 2),
        url = _streamUrl$split2[0],
        search = _streamUrl$split2[1];

    if (search) {
      this.parts = search.split('&').concat(this.parts);
    }
    return url + '?' + this.parts.join('&');
  }
};

var LiveSeekPlayer = function (_Player) {
  (0, _inherits3.default)(LiveSeekPlayer, _Player);

  function LiveSeekPlayer(hlsjsPlayer) {
    (0, _classCallCheck3.default)(this, LiveSeekPlayer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LiveSeekPlayer.__proto__ || (0, _getPrototypeOf2.default)(LiveSeekPlayer)).call(this, _playerName2.default.LiveSeekPlayer));

    _this.hlsjsPlayer = hlsjsPlayer;
    _this.hlsjsPlayer.inheritConfigs({ isLiveSeek: true });
    _this.url = null;
    _this.format = null;
    _this.duration = null;
    _this.durationPoller = null;
    return _this;
  }

  (0, _createClass3.default)(LiveSeekPlayer, [{
    key: 'on',
    value: function on(event, callback) {
      this.hlsjsPlayer.on(event, callback);
      this.addListener(event, callback);
    }
  }, {
    key: 'off',
    value: function off(event, callback) {
      this.hlsjsPlayer.off(event, callback);
      this.removeListener(event, callback);
    }

    /**
     * Load method that loads the given url into the hlsjsPlayer and starts
     * manually polling for the duration from the url and AVAILABLE_DURATION_HEADER.
     * @param url {string}
     * @param format {string}
     * @returns {Promise<void>}
     */

  }, {
    key: 'load',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(url, format) {
        var liveSeekUrl, loadPromise, durationPromise;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this._stopDurationPolling();
                liveSeekUrl = liveSeekUrlBuilder.start().segs(10000).finish(url);
                loadPromise = this._load(liveSeekUrl, format);
                durationPromise = this._setDuration(url);
                _context.next = 6;
                return _promise2.default.all([durationPromise, loadPromise]);

              case 6:
                this.url = url;
                this.format = format;
                this._startDurationPolling();

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function load(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: 'play',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(playFromPositionPercent) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!playFromPositionPercent) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return this.seek(playFromPositionPercent);

              case 3:
                _context2.prev = 3;
                return _context2.abrupt('return', this.hlsjsPlayer.play());

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](3);

                (0, _logError2.default)(_logging.LIVE_SEEK_PLAY_ERROR, _context2.t0);
                throw _context2.t0;

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 7]]);
      }));

      function play(_x3) {
        return _ref2.apply(this, arguments);
      }

      return play;
    }()

    /**
     * A custom seek implementation that first unloads the currently set media player,
     * creates a liveSeekUrl based on the streaming API specifications (found here
     * https://tunein.atlassian.net/wiki/spaces/FNS/pages/232620284/Requesting+HLS+Streams+Playlist+Service+params),
     * and then loads the new liveSeekUrl into the media player and plays it. We are requesting
     * 10000 segments here in order to return an HLS manifest containing all of the segments
     * for the stream in order to properly reflect the media playback times. This will be optimized
     * in the future.
     *
     * @param percentage {number}
     * @returns {Promise<void>}
     */

  }, {
    key: 'seek',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(percentage) {
        var seekTime, url;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.unload();

              case 3:
                seekTime = (0, _percentageToTime2.default)(percentage, this.duration);
                url = liveSeekUrlBuilder.start().segs(10000).finish(this.url);
                _context3.next = 7;
                return this._load(url, this.format, seekTime);

              case 7:
                this.emit(_htmlMediaEvents2.default.seeked);
                _context3.next = 15;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](0);

                _debugger2.default.log('an error occurred while seeking', _context3.t0);
                this.emit(_htmlMediaEvents2.default.error, _context3.t0);
                (0, _logError2.default)(_logging.LIVE_SEEK_SEEK_ERROR, _context3.t0);

              case 15:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 10]]);
      }));

      function seek(_x4) {
        return _ref3.apply(this, arguments);
      }

      return seek;
    }()
  }, {
    key: 'pause',
    value: function pause() {
      return this.hlsjsPlayer.pause();
    }
  }, {
    key: 'stop',
    value: function stop() {
      return this.hlsjsPlayer.stop();
    }
  }, {
    key: 'unload',
    value: function unload() {
      return this.hlsjsPlayer.unload();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._stopDurationPolling();
      return this.hlsjsPlayer.destroy();
    }
  }, {
    key: 'canChangePlaybackRate',
    value: function canChangePlaybackRate() {
      return this.hlsjsPlayer.canChangePlaybackRate();
    }
  }, {
    key: 'getPlaybackRate',
    value: function getPlaybackRate() {
      return this.hlsjsPlayer.getPlaybackRate();
    }
  }, {
    key: 'changePlaybackRate',
    value: function changePlaybackRate(rate) {
      this.hlsjsPlayer.changePlaybackRate(rate);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(volume) {
      this.hlsjsPlayer.setVolume(volume);
    }
  }, {
    key: 'getVolume',
    value: function getVolume() {
      return this.hlsjsPlayer.getVolume();
    }
  }, {
    key: 'setTitle',
    value: function setTitle(title) {
      this.hlsjsPlayer.setTitle(title);
    }
  }, {
    key: 'getTimes',
    value: function getTimes() {
      try {
        var _ref4 = this.hlsjsPlayer.getTimes() || {},
            elapsedSeconds = _ref4.elapsedSeconds;

        if (!elapsedSeconds || !this.duration) {
          return {
            duration: 0,
            elapsedSeconds: 0,
            elapsedPercent: 0,
            isLiveSeekStream: true
          };
        }
        var seconds = elapsedSeconds > this.duration ? this.duration : elapsedSeconds;
        var percentage = (0, _timeToPercentage2.default)(seconds, this.duration);
        return {
          duration: this.duration,
          elapsedSeconds: elapsedSeconds,
          // The elapsed percent will never reach 100% when playing live seek streams. Seeking
          // to the live head, or 100%, actually seeks to a specified number of fragments
          // before the end of the stream. If the current time is within 20 seconds of the duration
          // of the media then assume that we are playing at the live head.
          elapsedPercent: seconds >= this.duration - LIVE_HEAD_DELAY ? 100 : percentage,
          isLiveSeekStream: true
        };
      } catch (ex) {
        _debugger2.default.log('could not get times for live seek player', ex);
        return {
          duration: 0,
          elapsedSeconds: 0,
          elapsedPercent: 0,
          isLiveSeekStream: true
        };
      }
    }
  }, {
    key: '_load',
    value: function _load(url, format, position) {
      try {
        return this.hlsjsPlayer.load(url, format, position);
      } catch (ex) {
        (0, _logError2.default)(_logging.LIVE_SEEK_LOAD_ERROR, ex);
        throw ex;
      }
    }
  }, {
    key: '_stopDurationPolling',
    value: function _stopDurationPolling() {
      if (this.durationPoller) {
        clearInterval(this.durationPoller);
      }
    }
  }, {
    key: '_setDuration',
    value: function () {
      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(url) {
        var pollingUrl, response, duration, newDuration;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                pollingUrl = liveSeekUrlBuilder.start().segs(1).finish(url);
                _context4.next = 4;
                return _axios2.default.get(pollingUrl);

              case 4:
                response = _context4.sent;
                duration = response.headers[AVAILABLE_DURATION_HEADER];

                if (duration) {
                  _context4.next = 8;
                  break;
                }

                return _context4.abrupt('return');

              case 8:
                newDuration = parseInt(duration, 10);

                if (!(newDuration <= this.duration)) {
                  _context4.next = 11;
                  break;
                }

                return _context4.abrupt('return');

              case 11:
                this.duration = newDuration;
                this.emit(_htmlMediaEvents2.default.timeupdate, this.getTimes());
                _context4.next = 19;
                break;

              case 15:
                _context4.prev = 15;
                _context4.t0 = _context4['catch'](0);

                (0, _logError2.default)(_logging.LIVE_SEEK_SET_DURATION_ERROR, _context4.t0);
                _debugger2.default.log('an error occurred while polling for duration', _context4.t0);

              case 19:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 15]]);
      }));

      function _setDuration(_x5) {
        return _ref5.apply(this, arguments);
      }

      return _setDuration;
    }()

    /**
     * Method to start polling for HLS live seek stream duration changes. Polling interval is
     * specified by DURATION_POLLING_INTERVAL constant.
     * @private
     */

  }, {
    key: '_startDurationPolling',
    value: function _startDurationPolling() {
      var _this2 = this;

      this.durationPoller = setInterval(function () {
        return _this2._setDuration(_this2.url);
      }, DURATION_POLLING_INTERVAL);
    }
  }]);
  return LiveSeekPlayer;
}(_Player3.default);

exports.default = LiveSeekPlayer;
//# sourceMappingURL=LiveSeekPlayer.js.map